module.exports = __webpack_public_path__ + "img/background_login.9840ab18.jpg";